// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoDialog--title {
  overflow-wrap: anywhere;
}

.videoDialog--content {
  padding-top: 5px;
}

.videoDialog--player {
  display: block;
  width: 100%;
  aspect-ratio: 16/9;
  max-height: 70vh;
  object-fit: contain;
  background-color: #000000;
}

.videoDialog--actions {
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 24px 20px;
}

.videoDialog--button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 170px;
  height: 36px;
  padding: 0 20px;
  border-radius: 30px;
  border: 1px solid var(--theme-secondary);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1px;
  cursor: pointer;
}
.videoDialog--button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.videoDialog--button__primary {
  background-color: var(--theme-secondary);
  color: #ffffff;
}

.videoDialog--button__secondary {
  background-color: #ffffff;
  color: var(--theme-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/intern/observation-video-dialog/observation-video-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,wCAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,6BAAA;AAAF","sourcesContent":[".videoDialog--title {\n  overflow-wrap: anywhere;\n}\n\n.videoDialog--content {\n  padding-top: 5px;\n}\n\n.videoDialog--player {\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  max-height: 70vh;\n  object-fit: contain;\n  background-color: #000000;\n}\n\n.videoDialog--actions {\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 10px 24px 20px;\n}\n\n.videoDialog--button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 170px;\n  height: 36px;\n  padding: 0 20px;\n  border-radius: 30px;\n  border: 1px solid var(--theme-secondary);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.videoDialog--button__primary {\n  background-color: var(--theme-secondary);\n  color: #ffffff;\n}\n\n.videoDialog--button__secondary {\n  background-color: #ffffff;\n  color: var(--theme-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
